<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App"
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";

@font-face {
  font-family: "MetaWebPro";
  src: url("./assets/fonts/ff_meta_web_pro_bold/MetaWebPro-Bold.woff")
    format("woff");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "MetaWebPro";
  src: url("./assets/fonts/ff_meta_web_thin/MetaWeb-Thin.woff") format("woff");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "MetaWebPro";
  src: url("./assets/fonts/ff_meta_web_pro_normal/MetaWebPro-Normal.woff")
    format("woff");
  font-weight: 400;
  font-style: normal;
}

html,
body,
#app,
section.section {
  font-family: "MetaWebPro", "Avenir", Helvetica, Arial, sans-serif !important;
  background: $base-background-color 0% 0% no-repeat padding-box !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
}

a {
  color: $base-color-green !important;
  text-decoration: none !important;

  &:hover {
    text-decoration: none !important;
  }
}
</style>
